// extracted by mini-css-extract-plugin
export default {"task-administration":"styles_task-administration__FsxuU"};